/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// A aba do legado era caminho (router.tsx); aqui é `?tab=` (S29).
export const Route = createFileRoute('/_app/pessoas-fisicas/todas/$personId/compliance')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/pessoas-fisicas/todas/$personId', params, search: { tab: 'compliance' } });
  },
});
